import { render, staticRenderFns } from "./top-customers.vue?vue&type=template&id=8d5fac0a"
import script from "./top-customers.vue?vue&type=script&lang=js"
export * from "./top-customers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports